import { render, staticRenderFns } from "./PoliceAlacakFormWizard.vue?vue&type=template&id=0db165a6"
import script from "./PoliceAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./PoliceAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports